import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { fontSize, fontFamily } from '../../constants/text';
import { colors } from '../../constants/colors';
import { analyticsTrackEvent } from '../../core/analytics';
import { LOGIN_CLICK_HEADER } from '../../core/analytics/events';
import history from '../../core/history';
import { getDefaultBreakpoint } from '../../core/util/device/screen';
import Hidden from '@material-ui/core/Hidden';
import { smallerThanOrEqualTo } from '../../core/util/styledComponents';
import Picture from '../SolvPatternLibrary/Picture';
import { LOGIN_ACTION_SIGN_UP, LOGIN_ACTION_SIGN_UP_VERIFY } from '../../constants';
import { isUndefined } from '../../core/util/object';
import { isClientSide } from '../../core/util/system';

const HEADER_HEIGHT = 56;

const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  height: ${HEADER_HEIGHT}px;
`;

const Header = styled.div`
  height: ${HEADER_HEIGHT}px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(130.49deg, #ff0e88 0%, #d000a4 100%);
`;

const SolvLogo = styled(Picture)`
  z-index: 1;
  height: 28px;
`;

const Back = styled(ArrowBack)`
  color: ${colors.theWhiteAlbum};
  font-size: ${fontSize.quiteExtraExtraLarge};
  cursor: pointer;
  z-index: 1;
  position: absolute;
  left: 25px;
  top: 15px;
`;

const Text = styled.p`
  font-size: ${fontSize.extraLarge};
  color: ${colors.theWhiteAlbum};
  font-family: ${fontFamily.bold};
  z-index: 1;
  ${smallerThanOrEqualTo.sm`
    font-size: ${fontSize.mediumLarge};
  `};
  text-align: center;
`;

class BrandedHeader extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    isModal: PropTypes.bool,
    closeModal: PropTypes.func,
    loginAction: PropTypes.string,
  };

  static defaultProps = {
    isModal: false,
  };

  handleClick = () => {
    analyticsTrackEvent(LOGIN_CLICK_HEADER);
    history.goBack();
  };

  isSignupScreen = () => {
    const { loginAction } = this.props;
    return (
      loginAction === LOGIN_ACTION_SIGN_UP ||
      loginAction === LOGIN_ACTION_SIGN_UP_VERIFY ||
      (isUndefined(loginAction) && isClientSide() && window.location.pathname.includes('sign-up'))
    );
  };
  render = () => {
    const { className, isModal } = this.props;

    return (
      <Fragment>
        <Hidden mdDown initialWidth={getDefaultBreakpoint()}>
          {(this.isSignupScreen() || isModal) && (
            <Root>
              <Header className={className} />
              {isModal && (
                <SolvLogo
                  imageObject={{ fullRes: '/images/logo/white_with_yellow_dot.png' }}
                  alt="Solv Logo"
                  onClick={this.handleClick}
                />
              )}
              {!isModal && <Text>Great doctors, available today.</Text>}
            </Root>
          )}
        </Hidden>
        <Hidden smUp initialWidth={getDefaultBreakpoint()}>
          <Root>
            <Hidden smUp initialWidth={getDefaultBreakpoint()}>
              <Back onClick={this.props.closeModal} />
            </Hidden>
            <Header className={className} />
            <SolvLogo
              imageObject={{ fullRes: '/images/logo/white_with_yellow_dot.png' }}
              alt="Solv Logo"
              onClick={this.handleClick}
            />
          </Root>
        </Hidden>
      </Fragment>
    );
  };
}

export default BrandedHeader;
